import React, { useState, useEffect } from "react";
import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiButtonIcon,
  EuiSpacer,
  EuiFieldText,
  EuiButton,
  EuiText,
  EuiButtonEmpty,
} from "@elastic/eui";
import axios from "axios";
import { getApiUrl } from "../utils/api";

const RatingComponent = ({ sessionId, sequenceNum, responseId }) => {
  const [rating, setRating] = useState(0);
  const [ratingExplanation, setRatingExplanation] = useState("");
  const [showExplanation, setShowExplanation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const fetchRating = async (sessionId, sequenceNum) => {
    try {
      const response = await axios.get(getApiUrl("/api/session/rating"), {
        params: {
          session_id: sessionId, // Use session_id instead of session_name
          sequenceNum: sequenceNum,
        },
      });
      if (response.data.rating !== undefined && response.data.rating !== null) {
        setRating(response.data.rating);
        setRatingExplanation(response.data.rating_explanation || "");
      }
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  useEffect(() => {
    fetchRating(sessionId, sequenceNum);
  }, [sessionId, sequenceNum]);

  const handleRatingChange = async (newRating) => {
    setRating(newRating);
    try {
      await axios.put(getApiUrl("/api/session/rating"), {
        session_id: sessionId, // Use session_id instead of session_name
        sequenceNum: sequenceNum,
        rating: newRating,
        rating_explanation: ratingExplanation,
      });
    } catch (error) {
      console.error("Error updating rating:", error);
    }
  };

  const handleExplanationChange = (e) => {
    setRatingExplanation(e.target.value);
  };

  const handleExplanationSubmit = async () => {
    setLoading(true);
    try {
      await axios.put(getApiUrl("/api/session/rating"), {
        session_id: sessionId, // Use session_id instead of session_name
        sequenceNum: sequenceNum,
        rating: rating,
        rating_explanation: ratingExplanation,
      });
      setSuccess(true);
      setShowExplanation(false);
      setRatingExplanation("");
      setTimeout(() => setSuccess(false), 2000); // Hide success message after 2 seconds
    } catch (error) {
      console.error("Error updating rating explanation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleExplanationSubmit();
    }
  };

  return (
    <div>
      <EuiFlexGroup gutterSize="s">
        {[1, 2, 3, 4, 5].map((star) => (
          <EuiFlexItem grow={false} key={star}>
            <EuiButtonIcon
              iconType={rating >= star ? "starFilled" : "starEmpty"}
              onClick={() => handleRatingChange(star)}
              aria-label={`${star} star`}
            />
          </EuiFlexItem>
        ))}
        <EuiFlexItem grow={false}>
          <EuiButtonEmpty
            size="s"
            iconType="comment"
            onClick={() => setShowExplanation(!showExplanation)}
          >
            Share more feedback? 💬
          </EuiButtonEmpty>
        </EuiFlexItem>
      </EuiFlexGroup>
      {showExplanation && (
        <EuiFlexGroup gutterSize="s">
          <EuiFlexItem>
            <EuiFieldText
              placeholder="Tell us what you think about this response ..."
              value={ratingExplanation}
              onChange={handleExplanationChange}
              onKeyDown={handleKeyPress}
            />
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton
              onClick={handleExplanationSubmit}
              isLoading={loading}
              iconType="arrowRight"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      )}
      {success && (
        <EuiText color="secondary">
          <p>Feedback sent successfully!</p>
        </EuiText>
      )}
      <EuiSpacer size="s" />
    </div>
  );
};

export default RatingComponent;
